import { useAssignSetting, useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { NEXTJS_ROUTER_CACHE_250124 } from "@faire/web-api--source/indigofair/settings/NEXTJS_ROUTER_CACHE_250124";

export const useAssignSettingNextJSRouterCache = () => {
  return useAssignSetting(NEXTJS_ROUTER_CACHE_250124);
};

export const useSettingNextJSRouterCacheEnabled = (): boolean =>
  useSetting(NEXTJS_ROUTER_CACHE_250124, 30) !== 30;